import React from "react";
import CollectionCard from "../Components/CollectionCard";
import LoadError from "../Components/LoadError";
import { getAllCategories, peekCategories } from "../utils/imageScanner";
import useRemoteData from "../utils/useRemoteData";

const grid = "grid gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3";

function Home() {
  const { data: categories, error, retry } = useRemoteData(getAllCategories, peekCategories);

  let content;
  if (error) {
    content = <LoadError onRetry={retry} />;
  } else if (!categories) {
    content = (
      <div className={grid} aria-busy="true" aria-label="Loading collections">
        {[0, 1, 2].map((i) => (
          <div key={i} className="shimmer aspect-[4/5] rounded-xl sm:aspect-[3/4]" />
        ))}
      </div>
    );
  } else if (categories.length === 0) {
    content = <p className="py-16 text-center text-base-content/70">No collections yet.</p>;
  } else {
    content = (
      <div className={grid}>
        {categories.map((category, i) => (
          <CollectionCard key={category.id} category={category} priority={i === 0} />
        ))}
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-6xl px-3 pb-8 sm:px-6">
      <header className="px-1 pb-4 pt-5 text-left sm:pb-8 sm:pt-10">
        <h1 className="text-[1.75rem] font-semibold leading-tight tracking-tight sm:text-4xl">
          The beauty of the world, one frame at a time
        </h1>
        <p className="mt-1.5 text-base-content/70">Pick a collection to start browsing.</p>
      </header>
      {content}
    </div>
  );
}

export default Home;
